import { BaseModel, Guid, RecursivePartial } from '@models/base';

export class TaskTarget extends BaseModel {
    id?: Guid;
    title?: string;
    description?: string;
    icon?: string;
    color?: string;
    recordTime?: boolean;
    canReach?: boolean;
    reason?: string;

    constructor(json?: RecursivePartial<TaskTarget>) {
        super(json);
        this.parseTaskTarget(json || {});
    }

    parse(json: RecursivePartial<TaskTarget>): TaskTarget {
        super.parse(json);
        this.parseTaskTarget(json);
        return this;
    }

    private parseTaskTarget(json: RecursivePartial<TaskTarget>): void {
        TaskTarget.assignFields<TaskTarget>(this, json, ['id', 'title', 'description', 'icon', 'color', 'recordTime', 'canReach', 'reason']);
    }

}
